import { Skeleton, SkeletonProps } from "@mui/material";

type CoreSkeletonWrapperProps = {
	/**If `loading`, returns skeleton. Otherwise returns `children` */
	loading?: boolean;
	children: React.ReactNode;
	/**@default 100% */
	width?: string | number;
	/**@default 100px */
	height?: number | string;
	customSkeleton?: React.ReactNode;
} & Omit<SkeletonProps, "height" | "width" | "children">;

export default function CoreSkeletonWrapper({
	children,
	loading,
	width = "100%",
	height = "100px",
	variant = "rounded",
	animation = "wave",
	customSkeleton,
	...props
}: CoreSkeletonWrapperProps) {
	if (!loading) return children;

	if (customSkeleton) return customSkeleton;

	return (
		<Skeleton {...props} variant={variant} animation={animation} width={width} height={height} aria-hidden="true" />
	);
}
